import * as React from "react";
import { ViewType } from "../../../NewsroomView";
import SimpleButton from "../../RenderComponents/SimpleButton";

interface IProps {
    config: any;
    isViewingArchivedItems: boolean;
    post: any;
    page: number;
    className?: string;
    type?: "a" | "button";
    text?: string;
    title?: string;
    ariaLabel?: string;
    onSwitchView: (view: ViewType, newsId: string) => void;
}

const ReadMoreButton = (props: IProps) => {
    const getReadPostUrl = (newsFriendlyUrl: string) => {
        const readMode = props.isViewingArchivedItems ? "archived" : "news";
        const url =  window.location.origin + window.location.pathname + window.location.search;
        return `${url}#/${props.config.portletInstanceId}/read/${readMode}/f/${newsFriendlyUrl}`;
    };

    const onReadPost = (newsId: string) => {
        props.onSwitchView(ViewType.Details, newsId);
    };

    return (
        <SimpleButton
            className={props.className || "NR_itemLink CMS_button CMS_bAction"}
            type={props.type}
            title={props.title}
            ariaLabel={props.ariaLabel}
            href={props.post ? getReadPostUrl(props.post.friendlyUrlName) : "#"}
            onClick={(e) => {
                e.preventDefault();
                onReadPost(props.post.newsId);
            }}
        >
            {props.text || "Read more"}
        </SimpleButton>
    );
};

export default ReadMoreButton;
